// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Image UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezImages-avatar-24x24 {
  height: 24px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-32x32 {
  height: 32px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-64x64 {
  height: 64px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-avatar-128x128 {
  height: 128px;
  border-radius: 3px;
  background-image: url("/public/images/avatars/ezclocker-engineer-orange.svg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.ezImages-small-help {
  padding: 0;
  border: 0;
  width: 18px;
  background-image: url("/public/images/icons/info.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.ezImages-actiongreen-check-left-container-24x24 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-ezActionGreen.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}

.ezImages-black-check-left-container-24x24 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-black.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}

.ezImages-black-check-left-container-18x18 {
  display: inline-block;
  padding: 0 0 0 30px;
  min-width: 28px;
  background-image: url("/public/images/icons/check-black.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}

.ezImages-hamburger-menu-button {
  display: inline-block;
  margin: 2px;
  padding: 0 0 0 30px;
  min-width: 24px;
  min-height: 24px;
  background-color: var(--ezClockerNavy);
  background-image: url("/public/images/icons/mobile-menu-white.svg");
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 18px 18px;
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-images.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,kBAAA;EACA,6EAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,UAAA;EACA,SAAA;EACA,WAAA;EACA,sDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,qEAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,6DAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,6DAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,mEAAA;EACA,gCAAA;EACA,4BAAA;EACA,0BAAA;AAAJ","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Image UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n.ezImages-avatar-24x24 {\r\n    height: 24px;\r\n    border-radius: 3px;\r\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.ezImages-avatar-32x32 {\r\n    height: 32px;\r\n    border-radius: 3px;\r\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.ezImages-avatar-64x64 {\r\n    height: 64px;\r\n    border-radius: 3px;\r\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.ezImages-avatar-128x128 {\r\n    height: 128px;\r\n    border-radius: 3px;\r\n    background-image: url('/public/images/avatars/ezclocker-engineer-orange.svg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.ezImages-small-help {\r\n    padding: 0;\r\n    border: 0;\r\n    width: 18px;\r\n    background-image: url('/public/images/icons/info.svg');\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n}\r\n\r\n.ezImages-actiongreen-check-left-container-24x24 {\r\n    display: inline-block;\r\n    padding: 0 0 0 30px;\r\n    min-width: 28px;\r\n    background-image: url('/public/images/icons/check-ezActionGreen.svg');\r\n    background-position: left center;\r\n    background-repeat: no-repeat;\r\n    background-size: 24px 24px;\r\n}\r\n\r\n.ezImages-black-check-left-container-24x24 {\r\n    display: inline-block;\r\n    padding: 0 0 0 30px;\r\n    min-width: 28px;\r\n    background-image: url('/public/images/icons/check-black.svg');\r\n    background-position: left center;\r\n    background-repeat: no-repeat;\r\n    background-size: 24px 24px;\r\n}\r\n\r\n.ezImages-black-check-left-container-18x18 {\r\n    display: inline-block;\r\n    padding: 0 0 0 30px;\r\n    min-width: 28px;\r\n    background-image: url('/public/images/icons/check-black.svg');\r\n    background-position: left center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px 18px;\r\n}\r\n\r\n.ezImages-hamburger-menu-button {\r\n    display: inline-block;\r\n    margin: 2px;\r\n    padding: 0 0 0 30px;\r\n    min-width: 24px;\r\n    min-height: 24px;\r\n    background-color: var(--ezClockerNavy);\r\n    background-image: url('/public/images/icons/mobile-menu-white.svg');\r\n    background-position: left center;\r\n    background-repeat: no-repeat;\r\n    background-size: 18px 18px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
